import axios from 'axios'
import config from '../../config'

const apiUrl = config.apiUrl;

let TokenApi = {
  async refreshAccessToken(refreshToken) {
    return axios.post(apiUrl + 'token/refresh', {
      refreshToken: refreshToken
    });
  }
};

export default TokenApi;



// WEBPACK FOOTER //
// ./src/api/Token/index.js